import { render, staticRenderFns } from "./vAlertHeader.vue?vue&type=template&id=211488bc"
import script from "./vAlertHeader.vue?vue&type=script&lang=js"
export * from "./vAlertHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports